import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Loading } from "common-import/custom";
import {isEmpty} from "lodash";
import {VarHelper} from "common-import/helpers"
import moment from "moment";

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

@inject("projectStore", "userStore", "masterStore") @observer
export default class AnswerDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      creator: {},
    }
  }

  async componentDidMount() {
    const { projectStore, match } = this.props;
    projectStore.answerDetail(match.params.id);
    await this.getUserDetailById(projectStore.currentAnswer.createdByUserId);
    this.setState({isLoading: false});
  };

  getUserDetailById = async (id) => {
    const { userStore } = this.props;
    const res = await userStore.getUserDetailById(id);
    if (!!res.error) return window.toast(JSON.stringify(res.error));
    this.setState({ creator: res.data });
  };

  renderCreator = () => {
    const { creator } = this.state;
    const answer = this.props.projectStore.currentAnswer;

    if (answer.isAnonymous) return (<h5>Anonymous</h5>);

    if (!isEmpty(creator) && !isEmpty(answer)) {
      return (
        <div className="block-content">
          <h4 className="block-content__title">Creator</h4>
          <div className="media user">
            <div className="media-left user-avatar"
                 style={{ backgroundImage: `url(${VarHelper.img(creator.avatar) || defaultImage})` }}>
            </div>
            <div className="media-body">
              <h4 className="media-heading">{creator.name}</h4>
              <p className="user__phone">
                <i className="fa fa-phone-square" aria-hidden="true"> </i> {creator.phone}
              </p>
              <p className="user__email">
                <i className="fa fa-envelope" aria-hidden="true"> </i> {creator.email}
              </p>
              <p className="user__created-date">
                <strong>Created at:</strong> {moment(answer.createdAt).format('LL')}
              </p>
              <p className="user__update-date">
                <strong>Last update:</strong> {moment(answer.updatedAt).format('LL')}
              </p>
            </div>
          </div>
        </div>
      )
    }
  };

  renderAnswerList = () => {
    const answer = this.props.projectStore.currentAnswer;
    return (
      <div className="block-content">
        <h4 className="block-content__title">Answers</h4>
        <div className="bidding__content">
          <div className="bidding__detail">
            {
              Object.entries(answer.answers).map(([key, value]) => {
                return (
                  <div key={key+value} className="raw-group">
                    <span className="key">{ key }</span>
                    <span className="string"> </span>
                    <span className="value">{ value }</span>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  };

  render() {
    const { isLoading } = this.state;
    if (isLoading) return (<Loading> </Loading>);
    return (
      <div className="animated fadeIn" id="answer-detail-page">
        <div className="card">
          <div className="card-header">

          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                {this.renderCreator()}
              </div>
              <div className="col-md-6">
                {this.renderAnswerList()}
              </div>
            </div>
          </div>
          <div className="card-footer">

          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/views/Projects/AnswerDetail.js